{
	"title": "Geo Nerd - Do you know ALL the countries in the world?",
	"description": "Do you know the countries of the world, capitals, flags? Let's see!",
	"home": {
		"title": "Do you know the world?",
		"subtitle": "Geo Nerd",
		"intro": "Whether you're into flags, capitals or maps, there's a mode made for you.",
		"flagNerd": "Flag Nerd",
		"flagNerdSubtitle": "Flag expert?",
		"capitalNerd": "Capital Nerd",
		"capitalNerdSubtitle": "Capital expert?",
		"countryNerd": "Country Nerd",
		"countryNerdSubtitle": "Do you know all the countries in the world?",
		"mapNerd": "Map Nerd",
		"mapNerdSubtitle": "Country expert?",
		"usStates": "US States",
		"usStatesSubtitle": "US states expert?",
		"dailyChallenge": "Daily Challenge",
		"dailyChallengeSubtitle": "20 questions, one shot!",
		"classic": "Classic",
		"hard": "Hard",
		"tricky": "Tricky",
		"speedRun": "Speed Run",
		"reverse": "Reverse",
		"list": "List",
		"betaTag": "Beta",
		"go": "GO",
		"resumeTitle": "Your game in progress",
		"reviewDue": "{n} mistakes to review today",
		"reviewDueOne": "1 mistake to review today",
		"lab": "The Lab",
		"labSubtitle": "Three new games to try, tell us what you think!",
		"resumeOthersOne": "other game in progress",
		"resumeOthers": "other games in progress"
	},
	"menu": {
		"home": "Home",
		"games": "Games",
		"pays": "Countries",
		"training": "Training",
		"settings": "Saves",
		"leaderboard": "Leaderboard",
		"aPropos": "About",
		"faq": "FAQ",
		"mentionsLegales": "Legal notice",
		"myProfile": "My profile",
		"inProgress": "Games in progress",
		"news": "What's new",
		"logout": "Log out",
		"login": "Log in",
		"register": "Sign up",
		"mainNav": "Main navigation",
		"openMenu": "Open menu",
		"accountMenu": "My account",
		"back": "Back",
		"passport": "My passport",
		"review": "Review my mistakes"
	},
	"settings": {
		"title": "Saves",
		"all": "All letters",
		"clearData": "Clear data",
		"clearFlagNerdClassic": "Clear Flag Nerd Classic",
		"clearFlagNerdHard": "Clear Flag Nerd Hard",
		"clearFlagNerdTricky": "Clear Flag Nerd Tricky",
		"clearCapitalNerdClassic": "Clear Capital Nerd Classic",
		"clearCapitalNerdHard": "Clear Capital Nerd Hard",
		"clearCountryNerd": "Clear Country Nerd",
		"clearMapNerdClassic": "Clear Map Nerd Classic",
		"clearMapNerdHard": "Clear Map Nerd Hard",
		"language": "Language",
		"reset": "Reset",
		"confirmTitle": "Confirmation",
		"confirmMessage": "Are you sure you want to reset this game?",
		"clearAllNotice": "All progress will be permanently deleted.",
		"cancel": "Cancel",
		"confirm": "Confirm"
	},
	"game": {
		"lives": "Lives",
		"best": "Best",
		"score": "Score",
		"capitalsFound": "Capitals found",
		"countriesFound": "Countries found",
		"countriesLeft": "Countries left",
		"validate": "OK",
		"tryAgain": "Try again",
		"restart": "Restart",
		"backHome": "Back",
		"won": "Well done!",
		"lost": "Lost!",
		"backToLetters": "Choose another letter",
		"replayLetter": "Replay this letter",
		"bestTime": "best",
		"newBestTime": "New best time!",
		"youWon": "You won!",
		"youLost": "Game over, can you beat your record?",
		"whatIsThisFlag": "What country is this flag from?",
		"whatIsThisCapital": "What is the capital of",
		"whichCountryCapital": "Which country has this capital?",
		"doYouKnowAllCapitals": "Do you know all the capitals?",
		"doYouKnowAllCountries": "Do you know all the countries in the world?",
		"countryNerdHelp": "Find all the countries in the world starting with each letter of the alphabet. Once a letter is done, you can move on to the next one!",
		"countryNerdHardHelp": "Find all the countries in the world starting with each letter of the alphabet. In Hard mode there's no hint about how many remain — you're on your own!",
		"findCountriesStartingWith": "Find countries starting with:",
		"wellDoneTryAnotherLetter": "Well done, try another letter?",
		"typeCountryName": "Type the country name",
		"typeCapitalName": "Type the capital name",
		"enterCountryStartingWith": "Enter a country starting with",
		"infiniteMode": "Infinite Mode",
		"continueInfinite": "Continue in Infinite Mode",
		"mapWon": "Impressive, you're a real&nbsp;<br>pro of the world's countries!",
		"chooseCountry": "Choose a country on the map",
		"howToPlay": "How to play?",
		"mapClassicHelp": "Find the indicated country by clicking on the map.<br>Be careful, you only have 3 lives!",
		"mapHardHelp": "Click on a country on the map and then type its name to validate. Be careful, you only have 3 lives!",
		"dontShowAgain": "Don't show again",
		"letsGo": "Let's go!",
		"speedRun": "Speed Run",
		"timeRemaining": "Time remaining",
		"timeUp": "Time's up !",
		"newBest": "New best!",
		"yourMistakes": "Your mistakes",
		"dailyChallenge": "Daily Challenge",
		"alreadyPlayed": "You've already played today, come back tomorrow!",
		"comeBackTomorrow": "Come back tomorrow for a new challenge!",
		"streak": "Current streak",
		"streakBest": "Best",
		"backToScopes": "Change area",
		"answerWas": "It was:",
		"elapsedTime": "Time",
		"bestScore": "Best score",
		"hint": "Hint",
		"hintConfirmMessage": "A hint counts as one more mistake on the leaderboard. Continue?",
		"lettersDone": "letters",
		"countriesTotal": "countries",
		"ready": "Ready?",
		"startRun": "Start the clock",
		"speedRunStartHelp": "The clock only starts when you hit Start, so take your time to get ready.",
		"usStatesWon": "Well done, you know all the&nbsp;<br>US states!",
		"chooseState": "Choose a state on the map",
		"usStatesClassicHelp": "Find the state shown by clicking on the map.<br>Watch out, you only have 3 lives!",
		"usStatesHardHelp": "Click a state on the map, then type its name to validate. Watch out, you only have 3 lives!",
		"typeStateName": "Type the state's name",
		"doYouKnowAllStates": "Do you know all the US states?",
		"usStatesListHelp": "Find all 50 US states by typing their name. They're placed in the list in alphabetical order as you go.",
		"statesFound": "States found"
	},
	"mapExploration": {
		"pickerTitle": "Choose your area",
		"worldLabel": "World",
		"rankedLabel": "Ranked",
		"trainingLabel": "Training",
		"title": "World Exploration",
		"rankLabel": "Rank",
		"discovered": "countries discovered",
		"focusContinent": "Continent to work on",
		"ranks": {
			"tourist": "Tourist",
			"explorer": "Explorer",
			"adventurer": "Adventurer",
			"globetrotter": "Globetrotter",
			"master": "Master of the World"
		},
		"continents": {
			"af": "Africa",
			"eu": "Europe",
			"as": "Asia & Oceania",
			"am": "Americas"
		}
	},
	"scores": {
		"noScore": "-",
		"myRecords": "My Records",
		"share": "Share my score",
		"shareGlobal": "Share all my scores",
		"copied": "Copied!",
		"copyFailed": "Copy failed",
		"gamesPlayed": "Games played",
		"averageScore": "Average score",
		"progression": "Progression",
		"reset": "Reset",
		"globalStats": "Global Statistics",
		"totalGamesPlayed": "Total games played",
		"successRate": "Success rate",
		"bestMode": "Best mode",
		"worstMode": "Needs work"
	},
	"training": {
		"directory": "Countries Directory",
		"directorySubtitle": "Flags & Capitals",
		"directoryIntro": "<p>This directory lists the <strong>193 member states of the United Nations</strong>, with their flag and capital city. Territories, dependencies and unrecognised states are left out: it is exactly the same scope as the Geo Nerd quizzes, so whatever you revise here pays off in game.</p><p>Use the search box to find a country by name, or the continent filters to focus on one region at a time: <strong>54 countries in Africa</strong>, <strong>44 in Europe</strong>, <strong>35 in the Americas</strong> and <strong>60 across Asia and Oceania</strong>. Countries are listed alphabetically, with the capital shown under each name.</p><p>Recognising a flag, recalling a capital and locating a country on a map do not rely on the same memory: alternating between the three is what makes it stick. Once you feel ready, go and test yourself.</p>",
		"directoryScope": "The 193 UN member states: territories, dependencies and unrecognised states do not appear in the game.",
		"directoryPlay": "Take the quizzes:",
		"worldMap": "World Map",
		"worldMapSubtitle": "Interactive exploration",
		"usStatesMap": "US States Map",
		"mapOk": "OK",
		"search": "Search a country...",
		"allContinents": "All",
		"tooltipMore": "Learn more"
	},
	"leaderboard": {
		"title": "Leaderboard",
		"subtitle": "World's best players",
		"rank": "Rank",
		"player": "Player",
		"score": "Score",
		"errors": "Errors",
		"lives": "Lives",
		"viewLeaderboard": "View leaderboard",
		"time": "Time",
		"empty": "No scores recorded for this mode yet.",
		"loading": "Loading…",
		"errorLoad": "Could not load the leaderboard.",
		"currentStreak": "Current streak",
		"exploration": "Exploration",
		"composite": "Global score",
		"global": "Global",
		"compositeExplanation": "This score combines every game mode into a single rating out of 1000: each best score counts for its share, with Hard versions weighted double.",
		"avgScore": "Avg.",
		"countriesFound": "Countries found",
		"livesLeft": "{n} lives left",
		"legacyInfoLabel": "About this score",
		"legacyScoreNote": "Scores shown without lives or time were set before Geo Nerd recorded time and mistakes. They are kept as they are, but rank after measured scores on an equal number of points. Geo Nerd is still under development, in beta — thanks for bearing with us!",
		"today": "today",
		"yesterday": "yesterday",
		"daysAgo": "{n}d ago",
		"monthsAgo": "{n}mo ago",
		"yourPosition": "Your rank: {rank}/{total}",
		"notRankedYet": "You have no score in this mode yet.",
		"gapToNext": "+{n} to pass {player}",
		"gapTiebreak": "Level with {player}: you need fewer mistakes or a better time",
		"findMe": "Find me",
		"playCta": "Play this mode",
		"resumeLabel": "You have a game in progress in this mode",
		"you": "You",
		"profileEmpty": "This player has no recorded score yet.",
		"profileMemberSince": "Member since {date}",
		"profileGamesPlayed": "{n} games played",
		"dailyMedalsTitle": "Medals",
		"periodAll": "All time",
		"periodWeek": "This week",
		"weekEndsDays": "Resets in {d}d {h}h (Monday, midnight UTC)",
		"weekEndsHours": "Resets in {h}h (Monday, midnight UTC)",
		"emptyWeek": "Nobody has played this mode yet this week: first place is up for grabs!"
	},
	"country": {
		"breadcrumbHome": "Home",
		"breadcrumbCountries": "Countries",
		"h1": "{name}: flag, capital and map",
		"metaTitle": "{name} flag: meaning, capital and map",
		"metaDescription": "{name} flag meaning, capital ({capital}), population and location map. Then a quiz to recognise all 193 flags of the world.",
		"intro": "{name} at a glance: its flag, its capital {capital}, its population and where it sits on the world map. Plus a way to test yourself afterwards.",
		"flagTitle": "{name} flag and its meaning",
		"flagAlt": "Flag — {name}",
		"mapTitle": "{name} on the world map",
		"mapAlt": "Location map — {name}",
		"exploreMap": "Explore on the world map",
		"factsTitle": "{name} in figures",
		"capital": "Capital",
		"population": "Population",
		"area": "Area",
		"currency": "Currency",
		"language": "Official language",
		"languages": "Official languages",
		"demonym": "Demonym",
		"nativeName": "Local name",
		"officialName": "Official name",
		"tld": "Internet domain",
		"phone": "Calling code",
		"continent": "Continent",
		"unMember": "UN member since",
		"bordersTitle": "{name}: bordering countries",
		"bordersCount": "{count} bordering countries",
		"bordersOne": "One bordering country",
		"bordersNone": "No land border.",
		"related": {
			"AF": "More countries in Africa",
			"EU": "More countries in Europe",
			"AS": "More countries in Asia and Oceania",
			"AM": "More countries in the Americas"
		},
		"playTitle": "Test your knowledge",
		"playIntro": "So you know this country? Check that you know the other 192 too.",
		"playFlag": "Guess the flags",
		"playCapital": "Guess the capitals",
		"playMap": "Locate countries on the map",
		"playDirectory": "Browse every country",
		"inhabitants": "inhabitants",
		"populationMillion": "{n} million inhabitants",
		"populationMillions": "{n} million inhabitants",
		"populationBillion": "{n} billion inhabitants",
		"populationBillions": "{n} billion inhabitants",
		"populationAsOf": "as of {year}",
		"source": "Data: Wikidata (CC0). Flags and map: Geo Nerd.",
		"sourceOsm": "Data: Wikidata (CC0). Flag: Geo Nerd. Map outline: © OpenStreetMap contributors (ODbL).",
		"sourceCcBy": "Data: Wikidata (CC0). Flag: Geo Nerd. Map outline: geoBoundaries, Wikimedia Commons (CC BY 2.5)."
	},
	"pages": {
		"404": {
			"title": "Page not found - Geo Nerd",
			"description": "Oops, this page doesn't exist or has been moved."
		},
		"leaderboard": {
			"title": "World Leaderboard - Geo Nerd",
			"description": "See how the best Geo Nerd players rank worldwide, mode by mode: flags, capitals, map and daily challenge."
		},
		"home": {
			"title": "Geo Nerd - Do you know ALL the countries in the world?",
			"description": "Test your knowledge of countries, capitals and flags from all over the world! Are you a real Geo Nerd?"
		},
		"pays": {
			"title": "Country Directory - Geo Nerd",
			"description": "Tons of information about all countries: flags, original names and capitals."
		},
		"trainingMap": {
			"title": "Interactive Map - Geo Nerd",
			"description": "Explore the world map freely and click on countries to discover their name, flag and capital."
		},
		"trainingMapUs": {
			"title": "Interactive US States Map - Geo Nerd",
			"description": "Explore the US states map freely and click on a state to discover its name and flag."
		},
		"aPropos": {
			"title": "About - Geo Nerd",
			"description": "What is Geo Nerd? A free geography quiz about the world's countries, flags and capitals, no account required."
		},
		"faq": {
			"title": "FAQ - Geo Nerd",
			"description": "Answers to the most common questions about Geo Nerd: scores, account, data, available languages."
		},
		"mentionsLegales": {
			"title": "Legal Notice - Geo Nerd",
			"description": "Geo Nerd's legal notice and privacy policy: publisher, host, data collected."
		},
		"flagNerdClassic": {
			"title": "Flag Nerd Classic - Guess the Flag - Geo Nerd",
			"description": "Guess the country corresponding to the flag displayed. A classic to learn while having fun!"
		},
		"flagNerdHard": {
			"title": "Flag Nerd Expert - Hard Challenge - Geo Nerd",
			"description": "Expert mode for flag champions. No help, just your talent!"
		},
		"flagNerdTricky": {
			"title": "Flag Nerd Tricky - Trick Flags - Geo Nerd",
			"description": "Deliberately misleading choices between look-alike flags. Don't get fooled!"
		},
		"flagNerdSpeedRun": {
			"title": "Flag Nerd Speed Run - Geo Nerd",
			"description": "How many flags can you identify in 60 seconds? Challenge your reflexes!"
		},
		"capitalNerdClassic": {
			"title": "Capital Nerd - World Capitals - Geo Nerd",
			"description": "Are you unbeatable on capitals? Test yourself on all the countries of the world!"
		},
		"capitalNerdHard": {
			"title": "Capital Nerd Expert - Capital from the Flag - Geo Nerd",
			"description": "Find the capital from the flag alone, among 4 choices. No country name shown!"
		},
		"capitalNerdSpeedRun": {
			"title": "Capital Nerd Speed Run - Geo Nerd",
			"description": "Speed and accuracy: find as many capitals as possible before the timer runs out!"
		},
		"capitalNerdReverse": {
			"title": "Capital Nerd Reverse - Which country has this capital? - Geo Nerd",
			"description": "The capitals challenge in reverse: we give you a capital, find the country among 4 choices!"
		},
		"countryNerd": {
			"title": "Country Nerd - Name Every Country A to Z - Geo Nerd",
			"description": "Free geography quiz: name every country in the world, letter by letter. No signup, play instantly."
		},
		"countryNerdHard": {
			"title": "Country Nerd Hard - The ABC of countries, no hints - Geo Nerd",
			"description": "Find all the countries starting with each letter, with no hint about the ones left to find. The ultimate challenge!"
		},
		"mapNerdClassic": {
			"title": "Map Nerd Classic - Where is this country? - Geo Nerd",
			"description": "We give you a name, you find the country on the world map! Avoid mistakes or it's game over."
		},
		"mapNerdHard": {
			"title": "Map Nerd Expert - Name the country - Geo Nerd",
			"description": "Click on a country on the map and write its name correctly. The ultimate geographical challenge."
		},
		"usStatesClassic": {
			"title": "US States Classic - Where is this state? - Geo Nerd",
			"description": "We give you a US state's name (and its flag), you find it on the map of the USA! Avoid mistakes or it's game over."
		},
		"usStatesHard": {
			"title": "US States Expert - Name the state - Geo Nerd",
			"description": "Click on a state on the map of the USA and write its name correctly. The ultimate geographical challenge."
		},
		"usStatesList": {
			"title": "US States List - All 50 US states - Geo Nerd",
			"description": "Find all 50 US states by typing their name, no map or timer required. How many do you know?"
		},
		"dailyChallenge": {
			"title": "Daily Challenge - Geo Nerd",
			"description": "20 increasingly hard questions, flags or capitals depending on the day, one attempt per day. Compare your score with friends!"
		},
		"dailyChallengeHard": {
			"title": "Daily Challenge Expert - Geo Nerd",
			"description": "20 questions with no choices, flags or capitals depending on the day, one attempt per day. The ultimate mode!"
		},
		"resetPassword": {
			"title": "Reset password - Geo Nerd",
			"description": "Set a new password to access your Geo Nerd account."
		},
		"geoadmin": {
			"title": "Admin - Geo Nerd",
			"description": "Geo Nerd administration."
		},
		"avatar": {
			"title": "My Avatar - Geo Nerd",
			"description": "Customize your Geo Nerd avatar: eyebrows, eyes, glasses, mouth, nose and color."
		},
		"profil": {
			"title": "My Profile - Geo Nerd",
			"description": "Your avatar, your username and your progress across every Geo Nerd game mode."
		},
		"partiesEnCours": {
			"title": "Games in Progress - Geo Nerd",
			"description": "Resume your unfinished Geo Nerd games, or give them up and start over."
		},
		"connexion": {
			"title": "Log In - Geo Nerd",
			"description": "Log in to sync your Geo Nerd scores across all your devices."
		},
		"inscription": {
			"title": "Sign Up - Geo Nerd",
			"description": "Create your Geo Nerd account to save your scores and join the world leaderboard."
		},
		"motDePasseOublie": {
			"title": "Forgotten Password - Geo Nerd",
			"description": "Get a link to choose a new Geo Nerd password."
		},
		"desinscription": {
			"title": "Unsubscribe from reminders - Geo Nerd",
			"description": "Stop receiving Geo Nerd Daily Challenge reminders."
		},
		"passeport": {
			"title": "My passport - Geo Nerd",
			"description": "Your flag, capital and map stamps, country by country."
		},
		"revision": {
			"title": "Review my mistakes - Geo Nerd",
			"description": "Missed flags and capitals come back at the right time, until you've got them."
		},
		"friendChallenge": {
			"title": "Challenge a friend: shareable geography quiz - Geo Nerd",
			"description": "10 geography questions, one link to send: your friend plays the same questions and you compare scores."
		},
		"borderNerd": {
			"title": "Border Nerd: neighbouring countries - Geo Nerd",
			"description": "Name all the neighbouring countries of each country. How many do you know?"
		},
		"shapeNerd": {
			"title": "Shape Nerd: recognize countries by their shape - Geo Nerd",
			"description": "Recognize the countries of the world by their outline, among countries of the same continent."
		},
		"shapeNerdHard": {
			"title": "Shape Nerd Hard: name countries by their shape - Geo Nerd",
			"description": "Recognize the countries of the world by their outline and type their name, with no choices to help you."
		}
	},
	"notFound": {
		"title": "Page not found",
		"description": "This page doesn't exist or has been moved.",
		"cta": "Back to home"
	},
	"errors": {
		"dataLoad": "Could not load country data. Check your connection and reload the page."
	},
	"account": {
		"title": "My account",
		"intro": "Create an account to save your scores online and find them again on all your devices.",
		"login": "Log in",
		"register": "Sign up",
		"usernamePlaceholder": "Username (3-20 chars: letters, digits, _ or -)",
		"emailPlaceholder": "Email",
		"passwordPlaceholder": "Password",
		"newPasswordPlaceholder": "Password (8 characters min.)",
		"loginCta": "Log in",
		"registerCta": "Create my account",
		"forgotLink": "Forgot your password?",
		"forgotIntro": "Enter your email and we'll send you a link to choose a new password.",
		"forgotCta": "Send the link",
		"forgotSent": "If an account exists for this email, a reset link has just been sent.",
		"backToLogin": "Back to login",
		"connectedAs": "Connected",
		"editField": "Edit",
		"saveProfile": "Save",
		"profileUpdated": "Your info has been updated.",
		"synced": "Your scores are saved online and synced across all your devices.",
		"logout": "Log out",
		"errors": {
			"network": "Can't reach the server. Please try again later.",
			"tooMany": "Too many attempts. Try again in a few minutes.",
			"alreadyRegistered": "This email or username is already taken.",
			"invalidCredentials": "Incorrect email or password.",
			"invalidInput": "Check the email and password (8 characters min.).",
			"invalidEmail": "Check the email address you entered.",
			"invalidPassword": "Invalid password: it must be between 8 and 200 characters.",
			"emailTaken": "This email is already used by another account.",
			"usernameTaken": "This username is already taken.",
			"generic": "Something went wrong. Please try again."
		},
		"reset": {
			"title": "New password",
			"intro": "Choose a new password for your Geo Nerd account.",
			"cta": "Confirm",
			"backHome": "Back to home",
			"goLogin": "Log in",
			"success": "Password updated! You can now log in.",
			"invalidToken": "This link is invalid or has expired. Please request a new reset.",
			"missingToken": "Invalid link: no reset token. Please request a new one from the login screen."
		},
		"editAvatar": "Edit my avatar",
		"loginIntro": "Log in to get your scores and your ranking back on every device.",
		"noAccount": "No account yet?",
		"haveAccount": "Already have an account?",
		"goRegister": "Create an account",
		"goLogin": "Log in",
		"forgotTitle": "Forgotten password",
		"reminderOptIn": "Email me a reminder on days I haven't played the Daily Challenge yet (unsubscribe in one click).",
		"newsNotice": "Your email is also used to tell you what's new in the game, a few times a year at most. You can opt out from your profile or in one click from any of these emails."
	},
	"notifications": {
		"title": "What's new"
	},
	"profile": {
		"title": "My profile",
		"subtitle": "Your avatar, your username and your progress.",
		"progressTitle": "My progress",
		"anonymousTitle": "You are playing without an account",
		"anonymousIntro": "Your progress is stored on this device only. Create an account to keep it everywhere and join the world leaderboard.",
		"anonymousName": "Anonymous player",
		"noUsername": "No username"
	},
	"inProgress": {
		"title": "Games in progress",
		"subtitle": "Pick a game up where you left it, or give it up and start over.",
		"empty": "No game in progress. Start a mode and it will show up here until you finish it.",
		"emptyCta": "See all games",
		"resume": "Resume",
		"abandon": "Give up",
		"abandonTitle": "Give this game up?",
		"abandonMessage": "This game's progress will be lost. Your best score is kept.",
		"progressLabel": "Progress",
		"livesLabel": "Lives left",
		"startedLabel": "Started",
		"elapsedLabel": "Time elapsed",
		"letterLabel": "Letter {letter}",
		"questionLabel": "Question {n}/{total}",
		"dailyLocked": "The daily challenge can't be given up: everyone gets a single try per day.",
		"today": "today",
		"yesterday": "yesterday",
		"daysAgo": "{n} days ago"
	},
	"avatar": {
		"title": "My avatar",
		"subtitle": "Customize your avatar",
		"random": "Random",
		"reset": "Default",
		"confirm": "Confirm",
		"color": "Color",
		"brows": "Eyebrows",
		"eyes": "Eyes",
		"glasses": "Glasses",
		"mouth": "Mouth",
		"nose": "Nose",
		"syncNote": "Log in to save your avatar across all your devices.",
		"saving": "Saving…",
		"saved": "Avatar saved on this device!",
		"savedSynced": "Avatar saved",
		"saveError": "Avatar saved on this device, but syncing failed."
	},
	"about": {
		"kicker": "The project",
		"h1": "About Geo Nerd",
		"lead": "Geo Nerd tests what you actually know about the world's countries: their flag, their capital, their spot on the map. No fluff, no bloated quiz — just the question asked straight, with a clock that shows no mercy in the harder modes.",
		"statCountriesLabel": "UN member states",
		"statModesLabel": "game modes across 7 families",
		"statMapLabel": "countries to place on the world map",
		"statsNote": "Free, ad-free, no sign-up required.",
		"modesTitle": "The seven game families",
		"modesIntro": "Each family has its own variants: multiple choice to learn, typed answers to check, a clock to make it hurt.",
		"modeDailyBody": "20 questions, the same for everyone, one attempt per day. Share your result as an emoji grid, your streak shows up on the leaderboard with flames, and your gold/silver/bronze medal count appears on your profile.",
		"modeDailyClassicDesc": "20 multiple-choice questions, one attempt per day.",
		"modeDailyHardDesc": "The same challenge, with no choices given.",
		"modeFlagBody": "A flag appears, you find the country. Multiple choice, typed, against the clock, or in the deliberately tricky version.",
		"modeFlagClassicDesc": "A flag shown, the country among 4 choices.",
		"modeFlagHardDesc": "Type the country name, no choices given.",
		"modeFlagSpeedRunDesc": "60 seconds on the clock, score as many as you can.",
		"modeFlagTrickyDesc": "Flags that really look alike, for experts.",
		"modeCapitalBody": "The capital of a country, the country behind a capital, or the capital hiding behind a bare flag.",
		"modeCapitalClassicDesc": "A country shown, its capital among 4 choices.",
		"modeCapitalHardDesc": "Just a flag, no country name shown.",
		"modeCapitalSpeedRunDesc": "The Classic mode, 60 seconds on the clock.",
		"modeCapitalReverseDesc": "A capital shown, find the matching country.",
		"modeMapBody": "A country name appears, and you click the right spot on the world map. 170 playable countries.",
		"modeMapClassicDesc": "Click the requested country on the world map.",
		"modeMapHardDesc": "Click the map, then type the country name.",
		"modeCountryBody": "The longest mode: all 193 countries, from memory, letter by letter, A to Z.",
		"modeCountryClassicDesc": "Every country to find, letter by letter.",
		"modeCountryHardDesc": "The same challenge, with no hint on how many are left.",
		"modeUsStatesBody": "All 50 US states, to locate on the map or recall from memory.",
		"modeUsStatesClassicDesc": "Find the named state by clicking the map.",
		"modeUsStatesHardDesc": "Click a state, then type its name.",
		"modeUsStatesListDesc": "Find all 50 states by typing their name.",
		"howTitle": "How it works",
		"howNoAccountTitle": "Playable without signing up",
		"howNoAccountBody": "Progress and best scores stay in your browser, even without creating an account.",
		"howAccountTitle": "An account to keep your progress",
		"howAccountBody": "Scores sync from one device to the next and join the global leaderboard, if that's your thing.",
		"howFreeTitle": "Free, with no ads",
		"howFreeBody": "No banners, no videos to sit through, no paid tier unlocking extra countries.",
		"howBilingualTitle": "Two languages, one site",
		"howBilingualBody": "Everything exists in English and French, including country and capital names.",
		"projectTitle": "Behind the scenes",
		"projectBody": "<p>Geo Nerd starts from the 193 UN member states, not one more or less: no territories, no dependencies, no unrecognised states, to keep the scope complete and identical from one game to the next.</p><p>The Daily Challenge draws the same questions for everyone from the date, a bit like Wordle, and when a flag changes in real life — Syria's did in late 2024 — it changes here too.</p><p>The site is built by one person, on their own time, with no studio or ad agency behind it. No framework, no account required: just enough code to make it work.</p>",
		"contactTitle": "Spotted a bug, or a flag that looks wrong?",
		"contactBody": "One message is enough — every piece of feedback gets read.",
		"supportTitle": "Support the project",
		"supportBody": "The site is free and will stay that way. Any donation helps pay for hosting.",
		"supportCta": "Support Geo Nerd",
		"faqCta": "More questions? The FAQ covers the most common ones.",
		"faqLink": "Read the FAQ",
		"ctaTitle": "Your turn to play",
		"ctaBody": "No sign-up to get started — just a first flag to recognise.",
		"ctaPlay": "Play",
		"ctaLeaderboard": "See the leaderboard",
		"modeLabBody": "Three new games in beta, to mix things up and go further than flags and capitals."
	},
	"howToPlay": {
		"h1": "How to play",
		"flagNerdClassic": "You're shown a flag, and you need to find the right country among 4 choices.",
		"flagNerdClassicTip": "A great way to discover every flag in the world with no pressure — the 4 choices make it easy to learn by elimination.",
		"flagNerdHard": "Same idea, but without the 4 choices to click: you type the country name on the keyboard (reasonable typos are forgiven).",
		"flagNerdHardTip": "With no choices to click, you actually need to know the country, not just recognize its flag among others.",
		"flagNerdTricky": "The 4 choices are deliberately tricky: flags that genuinely look alike. The mode for those who think they know it all.",
		"flagNerdTrickyTip": "So you never mix up Indonesia and Monaco, or Chad and Romania, again. This mode is still in beta: its scores do not count towards the leaderboard.",
		"flagNerdSpeedRun": "60 seconds, as many correct answers as possible. Every mistake takes 2 seconds off the clock.",
		"flagNerdSpeedRunTip": "The leaderboard keeps your best score — try to beat it every run.",
		"capitalNerdClassic": "You're given a country, find its capital among 4 choices.",
		"capitalNerdHard": "You're given a flag, with no country name shown: find the matching capital among 4 choices.",
		"capitalNerdHardTip": "You first need to recognize the country from its flag, then remember its capital — a real double challenge.",
		"capitalNerdSpeedRun": "The Capital Nerd Classic format, against a 60-second clock.",
		"capitalNerdSpeedRunTip": "Precision matters as much as speed — sometimes it's better to skip a question than to guess wrong.",
		"capitalNerdReverse": "The reverse mode: you're given a capital, and you find the country among 4 choices.",
		"capitalNerdReverseTip": "A good way to check that you really know the capitals, not just the countries.",
		"countryNerd": "Find every country in the world, letter by letter: the number of countries left is shown for each letter.",
		"countryNerdTip": "The counter shown on each letter tells you how many countries are left to find, never which ones.",
		"countryNerdHard": "The same challenge, with no hint about how many countries are left for each letter.",
		"countryNerdHardTip": "With no hint about how many countries are left, you really need to know the alphabet of countries by heart.",
		"usStatesList": "Find all 50 US states by typing their name: they're placed in the list in alphabetical order as you go.",
		"trainingMapTitle": "Training",
		"trainingMap": "Click any country to discover its name, flag and capital — no timer, no lives.",
		"trainingMapTip": "A great way to revise before trying Map Nerd's timed or lives-based modes.",
		"trainingMapUs": "Click any US state to discover its name and flag — no timer, no lives.",
		"trainingMapUsTip": "A great way to revise before trying US States' timed or lives-based modes.",
		"dailyChallenge": "20 increasingly hard questions, the same for everyone: flags on Monday, Wednesday, Friday and Sunday, capitals on Tuesday and Thursday, both on Saturday. One attempt per day, and you can compare your result with friends using the shareable result grid.",
		"dailyChallengeHard": "The Daily Challenge without the 4 choices: type the country name, or the capital's name on capital days.",
		"dailyChallengeHardTip": "The same challenge as the classic version, but with no choices at all: 20 questions to answer from memory.",
		"labBeta": "This mode is in beta: it doesn't count on the leaderboard yet, and your feedback is welcome.",
		"friendChallenge": "Pick a theme and answer 10 increasingly hard questions. Then send the link: your friend plays the exact same questions and finds out who won.",
		"borderNerd": "A country appears: type the names of all its neighbours. A country that isn't a neighbour costs a life, and so does \"Skip\", which reveals the missing ones.",
		"shapeNerd": "Recognize each country by its shape among four countries of the same continent. Three mistakes and it's over.",
		"shapeNerdHard": "Recognize each country by its shape and type its name: no choices this time. A small typo is fine, three mistakes and it's over."
	},
	"faq": {
		"kicker": "Help",
		"h1": "Frequently asked questions",
		"lead": "How games work, accounts, data, which countries are included: here is what people ask us most often.",
		"groupGame": "Playing",
		"groupAccount": "Account, scores and leaderboard",
		"groupContent": "What's in the game",
		"contactLink": "Send a message",
		"aboutLink": "Read the About page",
		"items": {
			"isFree": {
				"q": "Is Geo Nerd free?",
				"a": "Yes, Geo Nerd is entirely free and ad-free. If you enjoy the site, you can support its development via the \"Buy me a coffee\" link at the bottom of the page — that's entirely optional."
			},
			"howGamesWork": {
				"q": "How does a game work?",
				"a": "Most modes are lives-based: 3 hearts to start with, one heart lost per mistake, and the game ends on the third. Speed Run modes replace lives with a 60-second clock, each mistake taking 2 seconds off."
			},
			"typos": {
				"q": "Are typos accepted?",
				"a": "Yes, in the modes where you type the name: a missing letter, an extra letter or two swapped letters all go through. Two countries whose names look too much alike, however, are never accepted for one another."
			},
			"resume": {
				"q": "What happens if I leave a game halfway through?",
				"a": "It picks up where you left off. Lives, mistakes and the clock are saved as you play: reloading the page or coming back later resets nothing."
			},
			"dailyChallengeFaq": {
				"q": "How does the Daily Challenge work?",
				"a": "20 identical questions for everyone each day, one attempt allowed. The result can be shared as a Wordle-style grid."
			},
			"mobile": {
				"q": "Does Geo Nerd work on mobile?",
				"a": "Yes, every game mode (including the interactive map) is fully playable with touch on mobile and tablet."
			},
			"sound": {
				"q": "Can I turn the sound off?",
				"a": "Yes, with the speaker icon at the top of the page, and your choice is remembered. Sounds are generated by the browser, so there is no audio file to download."
			},
			"accountRequired": {
				"q": "Do I need an account to play?",
				"a": "No. Without an account, your progress and best scores are saved in your browser. Creating an account also lets you find them again on another device, and appear on the global leaderboard."
			},
			"dataCollected": {
				"q": "What data does Geo Nerd collect?",
				"a": "Without an account: none, everything stays in your browser. With an account: your email, username, password (never stored or readable in plain text) and scores, used only to make syncing work. Details are in the <a href=\"/mentions-legales\">legal notice</a>."
			},
			"leaderboardRanking": {
				"q": "How does the leaderboard work?",
				"a": "Each mode has its own <a href=\"/leaderboard\">leaderboard</a>, based on your best score. On equal scores, the number of mistakes and then the time break the tie. An overall ranking combines the modes into a score out of 1000, where the hard versions count double."
			},
			"countryList": {
				"q": "Which countries are included in the game?",
				"a": "All 193 UN member states. You can browse them all in the <a href=\"/pays/\">country directory</a>."
			},
			"languages": {
				"q": "What languages is Geo Nerd available in?",
				"a": "French and English. The language can be switched at any time using the selector in the menu."
			},
			"training": {
				"q": "Can I practise without being scored?",
				"a": "Yes. The <a href=\"/training-map\">interactive world map</a> lets you click any country to see its name, flag and capital, with no lives and no clock. The <a href=\"/pays/\">country directory</a> gathers all 193 entries."
			},
			"feedback": {
				"q": "How do I report a bug or suggest an idea?",
				"a": "By email, at <a href=\"mailto:contact@geo-nerd.com\">contact@geo-nerd.com</a>. Bugs, suggestions, a flag or capital that looks wrong, a clumsy translation: every message gets read."
			}
		}
	},
	"legal": {
		"h1": "Legal notice & privacy policy",
		"updated": "Last updated: October 2026",
		"editorTitle": "Site publisher",
		"editorBody": "<p>Geo Nerd is published on a non-professional basis by Florian LUCAS, under French law. As the publisher is an individual not acting in a professional capacity, their home address is not published but remains available to any judicial or administrative authority upon request, in accordance with French law (LCEN, article 6-III).</p><p>Contact: <a href=\"mailto:contact@geo-nerd.com\">contact@geo-nerd.com</a></p>",
		"hostTitle": "Hosting",
		"hostBody": "<p>The site is hosted by OVH SAS, 2 rue Kellermann, 59100 Roubaix, France (RCS Lille Métropole 424 761 419 00045) — <a href=\"https://www.ovh.com\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">ovh.com</a>.</p>",
		"ipTitle": "Intellectual property",
		"ipBody": "<p>The code, text, visuals and design of Geo Nerd belong to Florian LUCAS, unless stated otherwise. The factual data in the country pages (population, area, currency…) comes from Wikidata, published under the CC0 (public domain) license. Small-country outlines on silhouettes and country-page maps come from Natural Earth (public domain), and, for the smallest ones, from geoBoundaries: outlines derived from OpenStreetMap (© OpenStreetMap contributors, ODbL license, <a href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\" rel=\"noopener noreferrer\">openstreetmap.org/copyright</a>) or from Wikimedia Commons (CC BY 2.5 or public domain).</p>",
		"privacyTitle": "Privacy policy",
		"privacyIntro": "<p>This section explains what data is processed when using Geo Nerd, in accordance with the General Data Protection Regulation (GDPR).</p>",
		"dataNoAccountTitle": "Without an account",
		"dataNoAccountBody": "<p>Your progress, best scores and preferences (sound, language) are stored only in your browser's local storage, on your device. You can clear them at any time from your browser settings.</p><p>To count players and see how many come back, a random identifier, unrelated to your identity, is created in your browser. It is sent to the server when you finish your first game, then at most once per day you visit, with the date. When you finish the Daily Challenge, your score is sent with that same identifier to show where you stand among the day's players. Every finished game is also counted with it (the game, the score and the day), to see which games are played. This data is only used for overall statistics, is never combined with other data and can't identify you. Daily scores are deleted after 60 days, counted games after 13 months, the identifier after 25 months without a visit.</p>",
		"dataAccountTitle": "With an account",
		"dataAccountBody": "<p>Creating an account is optional and lets you find your progress again on several devices. It involves storing, on the server (hosted by OVH, in France), your email, username, password (hashed, never stored or read in plain text), scores, language and time zone. This data is never sold or shared with third parties, and is never used for advertising profiling. It is kept as long as the account exists.</p><p>Your email is also used, a few times a year at most, to tell you what's new in the game. The legal basis is Geo Nerd's legitimate interest in keeping its players informed about the service. You can object at any time, from your profile or in one click from any of these emails, without affecting your reminders; the date you object is kept.</p><p>From your profile, you can delete your account for good, at any time.</p>",
		"cookiesTitle": "Cookies",
		"cookiesBody": "<p>Creating an account sets a single session cookie (technical, required to stay logged in, never read by third parties). Geo Nerd may also use Google Analytics to measure site audience (pages viewed, traffic source), without advertising profiling or data resale; see <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Google's privacy policy</a>.</p>",
		"rightsTitle": "Your rights",
		"rightsBody": "<p>Under the GDPR, you have the right to access, correct, delete and port your personal data, and you can withdraw your consent to reminders or object to news emails at any time. Account deletion, reminders and news emails are managed directly from your profile, and unsubscribing from the link in emails. For any other request, including a copy of your data: <a href=\"mailto:contact@geo-nerd.com\">contact@geo-nerd.com</a>. You can also file a complaint with the French data protection authority, the CNIL (<a href=\"https://www.cnil.fr\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">cnil.fr</a>).</p>",
		"remindersTitle": "Reminders and notifications",
		"remindersBody": "<p>Daily Challenge reminders are only sent if you asked for them: unchecked box at sign-up, switches in your profile. The legal basis is your consent, whose date is kept as proof, as is the date you withdraw it.</p><p><strong>By email</strong> (with an account): at most one email a day, at the time you choose, only if you haven't played yet, with an automatic pause after 7 reminders without a game. Emails are sent by the provider Resend (resend.com), which only uses them for that purpose. Every reminder contains a link to unsubscribe in one click, without logging in.</p><p><strong>By notification</strong> (with or without an account): your browser provides a subscription address specific to its notification service (Google, Mozilla or Apple), kept along with your language, time zone and chosen time. It is deleted as soon as you turn notifications off or your browser reports it as expired.</p>",
		"labBody": "<p>In The Lab's games, every finished game is counted with the same random identifier, and the rating or comment you choose to leave is kept to improve these games: 13 months for games, 2 years for feedback. Please avoid writing personal information in a comment.</p>"
	},
	"nudge": {
		"recordTitle": "New record!",
		"recordBody": "It only lives in this browser. Create a free account to keep it on all your devices and show up on the leaderboard.",
		"streakTitle": "Your streak counts",
		"streakBody": "{n} days in a row, saved only in this browser. Create a free account so you don't lose them.",
		"cta": "Create my account"
	},
	"daily": {
		"themeToday": "Today: {theme}",
		"theme": {
			"flags": "flags",
			"capitals": "capitals",
			"mix": "flags and capitals"
		},
		"capitalQuestion": "What is its capital?",
		"typeCapital": "Capital name",
		"percentile": {
			"few": "You're among the first to play today: come back later to compare with others.",
			"perfect": "Flawless! Only {pct}% of today's {total} players did as well.",
			"better": "Better than {pct}% of today's {total} players."
		},
		"jokerUsed": "Joker used: the missed day doesn't break your streak.",
		"jokerReady": "Joker ready: a missed day won't break your streak.",
		"jokerRecharge": "Joker ready again in {n} days.",
		"historyTitle": "Your challenges",
		"historySummary": "{n} played, {avg}/20 on average",
		"nextIn": "Next challenge in",
		"newChallengeReady": "it's time, reload the page!",
		"meanwhile": "Meanwhile:",
		"tryHard": "today's Hard challenge",
		"tryClassic": "today's Classic challenge",
		"remindMe": "Remind me tomorrow",
		"remindMeNote": "At most one notification a day, only if you haven't played yet. You can turn it off from your profile.",
		"remindMeDone": "Got it: a reminder around {hour} on days you haven't played yet. Settings are in your profile.",
		"historySummaryOne": "1 played, {avg}/20"
	},
	"unsubscribe": {
		"title": "Unsubscribe",
		"working": "One moment…",
		"done": "Done: {email} won't receive Daily Challenge reminders anymore.",
		"undo": "My mistake, subscribe me again",
		"undone": "Reminders turned back on for {email}.",
		"invalid": "This unsubscribe link is no longer valid. You can also manage reminders from your profile.",
		"error": "The server isn't responding right now. Try again in a moment, or write to contact@geo-nerd.com.",
		"home": "Back to the game",
		"doneNews": "Done: {email} won't receive Geo Nerd news anymore. Your Daily Challenge reminders, if you turned them on, stay as they are.",
		"undoneNews": "News turned back on for {email}."
	},
	"reminders": {
		"title": "Daily Challenge reminders",
		"intro": "A short note on days you haven't played yet, never more than one a day. Automatic pause after 7 reminders without a game.",
		"email": "By email",
		"paused": "Paused after 7 reminders without a game: turn them back on to receive them again.",
		"emailNeedsAccount": "Email reminders require a <a href=\"/inscription\">free account</a>.",
		"push": "By notification on this device",
		"pushIos": "On iPhone, notifications require installing Geo Nerd: tap Share, then \"Add to Home Screen\".",
		"pushBlocked": "Geo Nerd notifications are blocked in your browser: allow them in its settings to turn them on here.",
		"hour": "Reminder time",
		"legal": "Your email is only used for your account, these reminders and, a few times a year, news about the game. Details are in the <a href=\"/mentions-legales\">privacy policy</a>.",
		"error": "This setting couldn't be saved. Try again in a moment.",
		"emailOn": "Email reminders turned on. A confirmation email is on its way.",
		"emailOff": "Email reminders turned off.",
		"pushOn": "Notifications turned on for this device.",
		"pushOff": "Notifications turned off for this device.",
		"hourSaved": "Reminder time saved."
	},
	"privacy": {
		"title": "My data",
		"intro": "Delete your account for good, along with your online progress and reminders.",
		"delete": "Delete my account",
		"deleteConfirm": "This is permanent: your account, online progress and reminders will be erased. Progress saved on this device stays. Confirm with your password.",
		"deleteCta": "Delete for good",
		"cancel": "Cancel",
		"wrongPassword": "Wrong password."
	},
	"install": {
		"title": "Geo Nerd on your home screen",
		"body": "Today's challenge one tap away, full screen, like an app.",
		"iosBody": "On iPhone: tap Share, then \"Add to Home Screen\". You'll also be able to get the daily reminder there.",
		"cta": "Install",
		"later": "Later"
	},
	"passport": {
		"title": "My passport",
		"subtitle": "Three stamps per country: its flag, its capital and its place on the map. How many countries have you completed?",
		"profileTeaser": "The countries whose flag, capital and place on the map you know.",
		"completeLabel": "countries completed",
		"flags": "Flags",
		"capitals": "Capitals",
		"maps": "Map",
		"flag": "Flag",
		"capital": "Capital",
		"map": "Map",
		"notOnMap": "Not on the playable map",
		"allZones": "All",
		"onlyMissing": "Missing stamps only",
		"allDone": "Nothing left to complete here: well done!",
		"howTitle": "Earning stamps",
		"howFlag": "Flag: recognize it in <a href=\"/flag-nerd-classic\">Flag Nerd</a> or the Daily Challenge.",
		"howCapital": "Capital: find it in <a href=\"/capital-nerd-classic\">Capital Nerd</a> or the Daily Challenge on capital days.",
		"howMap": "Map: locate the country in <a href=\"/map-nerd-classic\">Map Nerd</a> (micro-states aren't on it, they complete without it).",
		"earned": "earned",
		"missing": "missing"
	},
	"zones": {
		"label": "Play area",
		"trainingNote": "Training game: only the World game counts on the leaderboard."
	},
	"review": {
		"title": "Review",
		"subtitle": "Your mistakes come back at the right time: right away, then 1, 3, 7 and 16 days later, until you've got them.",
		"statDue": "to review",
		"statLearning": "learning",
		"statMastered": "mastered",
		"start": "Review ({n})",
		"emptyDeck": "Nothing to review yet: every mistake on a flag or a capital, in any game, will show up here.",
		"nothingDue": "Nothing to review today. Next review: {date}.",
		"allMastered": "Everything is mastered: nothing left to review.",
		"flagQuestion": "Which country does this flag belong to?",
		"itWas": "It was: {answer}",
		"retained": "remembered",
		"moreDue": "{n} more to review today.",
		"nextOn": "Next review: {date}.",
		"backToOverview": "Continue"
	},
	"lab": {
		"shapeNerd": "Shape Nerd",
		"borderNerd": "Border Nerd",
		"dataError": "This game's data couldn't be loaded. Reload the page in a moment.",
		"shapeQuestion": "Which country is this?",
		"shapePitch": "Recognize a country by its shape",
		"borderQuestion": "Name all its neighbouring countries",
		"borderPlaceholder": "A neighbouring country",
		"borderCount": "{found}/{n} neighbours found",
		"borderUnknown": "Country not recognized: check the spelling.",
		"borderAlready": "{name} is already found.",
		"borderWrong": "{name} isn't a neighbour.",
		"borderSkip": "Skip",
		"borderSkipped": "Skipped",
		"borderPitch": "Name all the neighbouring countries",
		"challenge": {
			"title": "Challenge a friend",
			"short": "10 questions, one link to send",
			"pitch": "Pick a theme, answer 10 questions, then send the link: your friend plays the exact same questions and sees who wins.",
			"theme": {
				"flags": "Flags",
				"capitals": "Capitals",
				"borders": "Borders",
				"shapes": "Shapes",
				"all": "All modes"
			},
			"themeLine": "Theme: {theme}",
			"invite": "{name} challenges you!",
			"someone": "Someone",
			"theirResult": "Their score: {score}/10 in {time}.",
			"accept": "Accept the challenge",
			"win": "You beat {name}!",
			"lose": "{name} keeps the edge this time.",
			"tie": "Perfect tie with {name}!",
			"yourName": "Your first name or nickname (shown to your friend)",
			"send": "Challenge a friend",
			"sendBack": "Send the challenge back",
			"new": "New challenge",
			"shareText": "I scored {score}/10 on this Geo Nerd challenge. Your turn:",
			"themeName": {
				"flags": "flags",
				"capitals": "capitals",
				"borders": "borders",
				"shapes": "shapes",
				"all": "all modes",
				"mix": "flags and capitals"
			},
			"borderQuestion": "Which of these countries borders it?",
			"loading": "Getting the challenge ready…",
			"loadError": "This theme couldn't load. Check your connection and try again.",
			"retry": "Try again"
		},
		"rating": {
			"title": "Did you enjoy this mode?",
			"again": "Your rating for this mode (you can change it)",
			"placeholder": "A word to help us improve it (optional)",
			"send": "Send",
			"thanks": "Thanks for rating!",
			"thanksComment": "Thanks, your feedback helps us improve The Lab!"
		},
		"play": "Play",
		"shapeNerdHard": "Shape Nerd Hard",
		"shapeHardPitch": "The outline, no choices: type the country name"
	},
	"newsEmail": {
		"title": "News",
		"intro": "An email when Geo Nerd really changes (new games, new modes), a few times a year at most.",
		"toggle": "Geo Nerd news by email",
		"on": "You'll get the next news.",
		"off": "Done: no more news emails. Your reminders stay as they are."
	}
}
